export const SKILL_CATEGORIES = [
  { id: 'general',    label: 'General',      icon: '✦' },
  { id: 'marketing',  label: 'Marketing',    icon: '📣' },
  { id: 'writing',    label: 'Writing',      icon: '✍️' },
  { id: 'coding',     label: 'Coding',       icon: '💻' },
  { id: 'seo',        label: 'SEO',          icon: '🔍' },
  { id: 'research',   label: 'Research',     icon: '🔬' },
  { id: 'creative',   label: 'Creative',     icon: '🎨' },
  { id: 'business',   label: 'Business',     icon: '💼' },
  { id: 'social',     label: 'Social Media', icon: '📱' },
  { id: 'education',  label: 'Education',    icon: '📚' },
  { id: 'image',      label: 'Image Gen',    icon: '🖼' },
  { id: 'video',      label: 'Video Gen',    icon: '🎬' },
];

/**
 * Parse {{variable_name}} placeholders from a prompt string.
 * Returns an array of unique variable names in order of appearance.
 */
export function parseVariables(prompt) {
  const matches = prompt.match(/\{\{([^}]+)\}\}/g) || [];
  const seen = new Set();
  return matches
    .map(m => m.slice(2, -2).trim())
    .filter(name => {
      if (seen.has(name)) return false;
      seen.add(name);
      return name.length > 0;
    });
}

/**
 * Replace {{variable}} placeholders in a prompt with provided values.
 * Missing values are left as-is.
 */
export function assemblePrompt(template, values) {
  return template.replace(/\{\{([^}]+)\}\}/g, (match, name) => {
    const key = name.trim();
    return values[key] !== undefined && values[key] !== '' ? values[key] : match;
  });
}

/**
 * Convert a raw variable name to a readable label.
 * e.g. "target_audience" → "Target audience"
 */
export function varLabel(name) {
  return name.replace(/_/g, ' ').replace(/\b\w/, c => c.toUpperCase());
}

/**
 * Check if all required variables are filled.
 */
export function validateVarValues(variables, values) {
  return variables
    .filter(v => v.required)
    .every(v => values[v.name] && values[v.name].trim());
}
